import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    FunctionField,
    ImageField,
    TextInput,
    SelectInput,
    Filter,
    TopToolbar,
    FilterButton,
    DateTimeInput,
    Pagination,
} from 'react-admin';
import Icon from '@mui/icons-material/Book';
import TimestampsPreviewField from '../components/TimestampsPreviewField';

export const VolleyMatchIcon = Icon;

const categoryChoices = [
    { id: 'senior', name: 'Senior' },
    { id: 'junior', name: 'Junior' },
    { id: 'league', name: 'League' },
];

const filterArray = [
    <SelectInput source="category" label="Category" choices={categoryChoices} />,
    <TextInput source="competition_category" label="Competition Category" />,
    <TextInput source="competition_parent" label="Competition Parent" />,
    <TextInput source="match_code" label="Match Code" />,
    <TextInput source="competition_code_like" label="Competition Code" />,
    <TextInput source="competition_name_like" label="Competition Name" />,
    <TextInput source="team_like" label="Team (A or B)" />,
    <TextInput source="EQA_nom_like" label="Team A" />,
    <TextInput source="EQB_nom_like" label="Team B" />,
    <TextInput source="poule_like" label="Poule" />,
    <TextInput source="niveau_like" label="Niveau" />,
    <TextInput source="district_like" label="District" />,
    <TextInput source="codent" label="Codent" />,
    <DateTimeInput source="start" />,
    <DateTimeInput source="end" />,
];

const FilterList = (props) => (
    <Filter {...props}>{filterArray}</Filter>
);

const ListActions = (props) => (
    <TopToolbar>
        <FilterButton filters={filterArray} />
    </TopToolbar>
);

export const VolleyMatchList = (props) => (
    <List {...props} filters={<FilterList />} actions={<ListActions />} perPage={50} pagination={<Pagination rowsPerPageOptions={[10, 50, 100, 200]} />}>
        <Datagrid>
            <TextField source="id" label="ID" />
            <TextField source="category" label="Category" />
            <TextField source="competition_category" label="Competition Category" />
            <TextField source="competition_parent" label="Competition Parent" />
            <TextField source="match_code" label="Match Code" />
            <TextField source="competition_intern_code" label="Competition Code" />
            <TextField source="competition_name" label="Competition Name" />
            <ImageField source="logo" label="Competition Logo" />
            <TextField source="codent" label="Codent" />
            <TextField source="poule" label="Poule" />
            <TextField source="tour" label="Tour" />
            <TextField source="niveau" label="Niveau" />
            <TextField source="district" label="District" />
            <TextField source="region" label="Region" />
            <TextField source="jo" label="JO" />
            <TextField source="EQA_nom" label="Team A" />
            <ImageField source="EQA_image" label="Logo Team A" />
            <TextField source="EQB_nom" label="Team B" />
            <ImageField source="EQB_image" label="Logo Team B" />
            <FunctionField label="Score" render={(record) => `${record.Score}`} />
            <FunctionField label="Set" render={(record) => `${record.Set_equipe1}/${record.Set_equipe2}`} />
            <TextField source="Total" label="Total Points" />
            <TextField source="Salle" label="Venue" />
            <TextField source="Arb1" label="Referee 1" />
            <TextField source="Arb2" label="Referee 2" />
            <DateField source="match_date" label="Match Date" showTime={false} />
            <TextField source="match_time" label="Match Time" />
            <DateField source="updatedAt" label="Last Updated" showTime={true} />
            <TimestampsPreviewField source="updatedAt_list" />
            <TimestampsPreviewField source="updatedAt_fast" />
            <TimestampsPreviewField source="updatedAt_past" />
            <FunctionField label="Link" render={(record) => record.compete_url ? <a href={record.compete_url} target='_blank' rel='noreferrer'>Link</a> : null} />
        </Datagrid>
    </List>
);
